export const Roles = {
  supportUser: "SUPPORT USER",
  generalPractitioner: "GENERAL PRACTITIONER",
};
